import Vue from "vue";
import Component from "vue-class-component";
import Router from "vue-router";
// Own components
import SidebarComponent from "@/components/sidebar/sidebar.component.vue";
import HeaderComponent from "@/components/header/header.component.vue";
import LoaderComponent from "@/components/loader/loader.component.vue";
import ModalPermissionsComponent from "@/components/modal-permissions/modal-permissions.component.vue";
import ModalLoginComponent from "@/components/modal-login/modal-login.component.vue";
// External components
import Datepicker from "vuejs-datepicker";
// Services
import AdminService from "@/core/services/admin.service.ts";
import SidebarService from "@/core/services/sidebar.service.ts";

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    Datepicker,
  },
})
export default class AdminsListComponent extends Vue {
  // Service's Instance
  adminService: any = new AdminService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  modal: boolean = false;
  deleteIcon: boolean = false;
  searchCompanyFlag: boolean = false;
  searchRolFlag: boolean = false;
  nextPositionDisabled: boolean = false;
  previousPositionDisabled: boolean = true;
  pagination: boolean = true;
  userToDelete: any;
  searchFlag: any = [];
  adminList: any = [];
  filterAdminList: any = [];
  companyList: any = [];
  roleList: any = [];
  name: string = "";
  search: string = "";
  company: any = [];
  companies: any = "default";
  finderCompanies: string = "default";
  role: any = [];
  roles: any = "default";
  finderRoles: string = "default";
  companyName: string = "";
  searchByDate: any = "defaultDate";
  createdAt: string = "";
  filterConcatDate: string = "";
  companyToSearch: string = "";
  pageOffset: number = 0;
  itemsPerPage: number = 50;
  totalPages: number;
  currentPage: number = 1;
  nextPage: number = 2;
  totalOfAdmins: number = 0;
  itemsOfFrom: number = 0;
  itemsOfTo: number = 0;
  isTokenTimeOut: boolean = false;
  mounted() {
    const _ = this;
    _.get(_.pageOffset, _.itemsPerPage);
    _.filterDate();
    _.getCompanies();
    _.getRoles();
  }

  filterByDate() {
    const _ = this;
    _.deleteIcon = true;
    let day =
      _.searchByDate.getDate() < 10
        ? "0" + _.searchByDate.getDate()
        : _.searchByDate.getDate();
    let month =
      _.searchByDate.getMonth() < 10
        ? "0" + (_.searchByDate.getMonth() + 1)
        : _.searchByDate.getMonth() + 1;
    let year = _.searchByDate.getFullYear();
    _.filterConcatDate = `${year}-${month}-${day}`;
    if (_.finderCompanies == "default") {
      _.filterAdminList = _.adminList.filter((admin) => {
        let parseDate: any = admin.createdAt.split("T");
        parseDate = parseDate[0];
        return _.filterConcatDate == parseDate;
      });
      return;
    }
    _.filterAdminList = _.adminList.filter((admin) => {
      let parseDate: any = admin.createdAt.split("T");
      parseDate = parseDate[0];
      return (
        admin.company.name == _.finderCompanies &&
        _.filterConcatDate == parseDate
      );
      console.log(_.finderCompanies);
    });

    if (_.finderRoles == "default") {
      _.filterAdminList = _.adminList.filter((admin) => {
        let parseDate: any = admin.createdAt.split("T");
        parseDate = parseDate[0];
        return _.filterConcatDate == parseDate;
      });
      return;
    }
    _.filterAdminList = _.adminList.filter((admin) => {
      let parseDate: any = admin.createdAt.split("T");
      parseDate = parseDate[0];
      return (
        admin.role.alias == _.finderRoles && _.filterConcatDate == parseDate
      );
      console.log(_.finderRoles);
    });
  }

  deleteDate() {
    const _ = this;
    _.filterConcatDate = "";
    _.deleteIcon = false;
    if (_.filterConcatDate == "") {
      _.searchByDate = "";
      _.filterAdminList = _.adminList;
      return;
    }
  }

  fiterByCompany(company) {
    const _ = this;
    if (company == "default" && _.filterConcatDate == "") {
      _.filterAdminList = _.adminList;
      return;
    }

    if (company == "default" && _.filterConcatDate != "") {
      _.filterAdminList = _.adminList.filter((admin) => {
        let parseDate: any = admin.createdAt.split("T");
        parseDate = parseDate[0];
        return _.filterConcatDate == parseDate;
        console.log(parseDate, "plplp");
      });
      return;
    }

    if (_.filterConcatDate != "") {
      _.filterAdminList = _.adminList.filter((admin) => {
        let parseDate: any = admin.createdAt.split("T");
        parseDate = parseDate[0];
        return admin.company.name == company && _.filterConcatDate == parseDate;
        console.log(company);
        console.log(parseDate);
      });
      return;
    }
    _.filterAdminList = _.adminList.filter((admin) => {
      return admin.company.name == company;
    });
  }

  fiterByRol(role) {
    const _ = this;
    if (role == "default" && _.filterConcatDate == "") {
      _.filterAdminList = _.adminList;
      return;
    }

    if (role == "default" && _.filterConcatDate != "") {
      _.filterAdminList = _.adminList.filter((admin) => {
        let parseDate: any = admin.createdAt.split("T");
        parseDate = parseDate[0];
        return _.filterConcatDate == parseDate;
        console.log(parseDate, "plplp");
      });
      return;
    }

    if (_.filterConcatDate != "") {
      _.filterAdminList = _.adminList.filter((admin) => {
        let parseDate: any = admin.createdAt.split("T");
        parseDate = parseDate[0];
        return admin.role.alias == role && _.filterConcatDate == parseDate;
        console.log(role);
        console.log(parseDate);
      });
      return;
    }
    _.filterAdminList = _.adminList.filter((admin) => {
      return admin.role.alias == role;
    });
  }

  filterDate(date: any = "") {
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  openModal(id) {
    const _ = this;
    _.userToDelete = id;
    _.modal = true;
  }

  getCompanies() {
    const _ = this;
    _.isLoading = true;
    _.adminService
      .getCompanies()
      .then((data: any) => {
        _.companyList = data["data"].companies;
        _.companyList.sort(function(a, b) {
          var textA = a.name.toLowerCase();
          var textB = b.name.toLowerCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        _.isLoading = false;
      });
  }

  getRoles() {
    const _ = this;
    _.isLoading = true;
    _.adminService
      .getRoles()
      .then((data: any) => {
        _.roleList = data["data"].roles;
        console.log(_.roleList, "_.roleList");
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        _.isLoading = false;
      });
  }

  replaceNullCompanies(users) {
    const _ = this;
    for (let i = 0; i < users.length; i++) {
      users[i].company =
        users[i].company == null ? { name: "" } : users[i].company;
    }
  }

  get(pageOffset = 0, itemsPerPage = 50) {
    const _ = this;
    console.log(pageOffset, itemsPerPage);
    _.isLoading = true;
    _.adminService
      .get(pageOffset, itemsPerPage)
      .then((data: any) => {
        _.adminList = data["data"].users;
        _.filterAdminList = data["data"].users;
        _.totalOfAdmins = data["data"].total;
        _.totalPages = Math.ceil(_.totalOfAdmins / itemsPerPage);
        console.log(_.totalPages, "totalPages");
        if (_.totalPages <= 1) {
          _.pagination = false;
        }
        if (pageOffset == 0) {
          _.itemsOfFrom = 1;
          _.itemsOfTo = _.adminList.length;
          _.previousPositionDisabled = true;
        }
        if (pageOffset != 0) {
          _.previousPositionDisabled = false;
        }
        if (pageOffset == _.totalPages - 1) {
          _.itemsOfTo = _.totalOfAdmins;
        }
        _.replaceNullCompanies(_.adminList);
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      })
      .catch((err) => {
        if (err.response.data.message.includes("Invalid or inexistent user")) {
          localStorage.removeItem("tk_auth");
          _.logInModal = true;
        }
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      });
  }

  delete_user() {
    const _ = this;
    _.isLoading = true;
    _.adminService
      .delete_user(_.userToDelete)
      .then((data: any) => {
        _.get();
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      });
  }

  nextPageAction() {
    const _ = this;
    _.itemsOfTo = _.itemsOfTo + _.adminList.length;
    _.itemsOfFrom = _.itemsOfFrom + _.adminList.length;
    _.pageOffset++;
    _.currentPage++;
    _.nextPage++;
    _.get(_.pageOffset);
    if (_.totalPages == _.currentPage) {
      _.nextPositionDisabled = true;
      return;
    }
  }

  previousPageAction() {
    const _ = this;
    if (_.currentPage == 1) {
      return;
    }
    _.itemsOfTo = _.itemsOfTo - _.adminList.length;
    _.itemsOfFrom = _.itemsOfFrom - _.adminList.length;
    _.pageOffset--;
    _.currentPage--;
    _.nextPage--;
    _.get(_.pageOffset);

    if (_.totalPages != _.currentPage) {
      _.nextPositionDisabled = false;
      return;
    }
  }
}
